import { TabContext, TabList } from "@mui/lab";
import { Link as RouterLink, useNavigate, useLocation } from "react-router-dom";
import {
  CircularProgress,
  IconButton,
  Tab,
  Tooltip,
  Link,
  Typography,
} from "@mui/material";
import React, { useEffect } from "react";
import ChatList from "./ChatList";
import AddIcon from "@mui/icons-material/Add";
import { useAppContext } from "src/hooks";

function ChatListSidebar({
  chatType,
  setChatType,
  chatCount,
  chatListPage,
  currentChat,
  setCurrentChat,
  loadMoreChats,
  setIsAddChatDrawerOpen,
  onChatClick,
  searchValue,
  setSearchValue,
  isMinHeight = false,
}) {
  const { chatList, setChatList, isOpenChatNotificationDialog, setIsOpenChatDialog, setIsOpenChatNotificationDialog, chatListLoading, } = useAppContext();
  return (
    <>
      <div className={isMinHeight ? "btn-container chatlist-fix-height" : "btn-container"} >
        {!chatListLoading && chatList.length > 0 && (
          <ChatList
            onChatClick={onChatClick}
            chatList={[...chatList]}
            chatListPage={chatListPage}
            setChatList={setChatList}
            currentChat={currentChat}
            chatCount={chatCount}
            setCurrentChat={setCurrentChat}
            loadMoreChats={loadMoreChats}
            isMinHeight={isMinHeight}
          />
        )}
        {!chatListLoading && chatList.length == 0 && (
          <div className="center-progress">
            <Typography textAlign="center" fontWeight="bold">
              No chats yet.
            </Typography>
          </div>
        )}
        {chatListLoading && (
          <CircularProgress
            className="circular-list"
          />
        )}
        {!isMinHeight ? <Tooltip title="New Chat" arrow>
          <IconButton
            className="add-chat-btn"
            aria-label="add"
            onClick={() => setIsAddChatDrawerOpen(true)}
          >
            <AddIcon htmlColor="#fff" />
          </IconButton>
        </Tooltip> :
          <div className="d-flex justify-content-end mt-3 view-all-chat-link">
            <Link
            component={RouterLink}
            variant="subtitle2"
            to="/chats"
            underline="hover"
            onClick={()=>{
              setIsOpenChatDialog(false);
              setIsOpenChatNotificationDialog(false);
              // navigate("/chats");
            }}
          >
            View all chats
          </Link>
          </div>
        }
      </div>
    </>
  );
}

export default ChatListSidebar;
